import { ApiLottoIdGetRequest, ApiLottoIdLottocertificazioniEsportaGetRequest, ApiLottoIdLottocertificazioniGetRequest, Configuration, LottoApi, LottoCertificazioniDtoPagedListDto, LottoDto } from "@desio/api";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { handleBlobResponse } from "helpers/utils";
import { ThunkApiConfig } from "store";
import getConfiguration, { errorHandler } from "store/config";
import { pageSize } from "store/utils";

export const refreshDettaglioLottoType = 'campagna/refreshDettaglioLotto';
export const refreshCertificazioniLottoType = 'campagna/refreshCertificazioniLotto';

export const getDettaglioLotto = createAsyncThunk<LottoDto | undefined, number, ThunkApiConfig>(
  'campagna/getDettaglioLotto', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-dettaglio-lotto.json')).default;
      } else {
        const request: ApiLottoIdGetRequest = {
          id,
        }
        return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoIdGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const refreshDettaglioLotto = createAsyncThunk<LottoDto | undefined, number, ThunkApiConfig>(
  refreshDettaglioLottoType, async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-dettaglio-lotto.json')).default;
      } else {
        const request: ApiLottoIdGetRequest = {
          id,
        }
        return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoIdGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);


export const getCertificazioniLotto = createAsyncThunk<LottoCertificazioniDtoPagedListDto | undefined, number, ThunkApiConfig>(
  'campagna/getCertificazioniLotto', async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-dettaglio-lotto.json')).default;
      } else {
        const request: ApiLottoIdLottocertificazioniGetRequest = {
          id,
          pageSize: pageSize,
          pageNumber: getState().dettaglioCampagna.paginaSelezionata || 1,
          workflow: getState().dettaglioCampagna.formRicerca.workflowCertificazione || undefined,
          stato: getState().dettaglioCampagna.formRicerca.statoCertificazione || undefined,
          nominativo: getState().dettaglioCampagna.formRicerca.nominativo || undefined,
        }
        return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoIdLottocertificazioniGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const refreshCertificazioniLotto = createAsyncThunk<LottoCertificazioniDtoPagedListDto | undefined, number, ThunkApiConfig>(
  refreshCertificazioniLottoType, async (id, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-dettaglio-lotto.json')).default;
      } else {
        const request: ApiLottoIdLottocertificazioniGetRequest = {
          id,
          pageSize: pageSize,
          pageNumber: 1,
          workflow: getState().dettaglioCampagna.formRicerca.workflowCertificazione || undefined,
          stato: getState().dettaglioCampagna.formRicerca.statoCertificazione || undefined,
          nominativo: getState().dettaglioCampagna.formRicerca.nominativo || undefined,
        }
        return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoIdLottocertificazioniGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const esportaCertificazioni = createAsyncThunk<void, ApiLottoIdLottocertificazioniEsportaGetRequest, ThunkApiConfig>(
  'campagna/esportaCertificazioni', async (request, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-dettaglio-lotto.json')).default;
      } else {
        const response = await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoIdLottocertificazioniEsportaGet(request);
        response && handleBlobResponse(response, "text/csv", `certificazioni_${request.id}_${request.tipoEsportazioneCertificazioni?.toString() || "0"}.csv`);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);


export const setPaginaSelezionataAction = createAction<number, 'campagna/setPaginaSelezionataAction'>('campagna/setPaginaSelezionataAction');

export const setRicercaNominativo = createAction<string, 'campagna/setRicercaNominativo'>('campagna/setRicercaNominativo');
export const setRicercaStatoCertificazione = createAction<number, 'campagna/setRicercaStatoCertificazione'>('campagna/setRicercaStatoCertificazione');
export const setRicercaWorkflowCertificazione = createAction<number, 'campagna/setRicercaWorkflowCertificazione'>('campagna/setRicercaWorkflowCertificazione');